import React from 'react';
import { connect } from 'react-redux';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, dsn, oem_id, oem_model, notification_type, property_name, display_name,
} from '../../filters/filterPanel/FilterPanel';
import ReportPage from '../ReportPage';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, devicesAlertSubscriptionByModel,
  devicesNotificationSentByPropertyName, devicesNotificationSubscriptionByPropertyName,
  devicesNotificationsSentByModel, devicesOnlineToday, listOfNotificationTypes,
  listOfOemModels, listOfOems, totalDatapoints, contractTotalDatapointsTransactions
} from '../../../services/reportsservice';
import './NotificationAnalysisPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";

class NotificationAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.NotificationAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return {
      filters: [
        listOfOemModels(filters),
        listOfOems(filters),
        listOfNotificationTypes(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
          activatedDevices(filters),
          contractTotalDatapointsTransactions(filters),
          devicesOnlineToday(filters),
          devicesAlertSubscriptionByModel(filters),
          devicesNotificationsSentByModel(filters),
          devicesNotificationSubscriptionByPropertyName(filters),
          devicesNotificationSentByPropertyName(filters),
        ]
        : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        devicesAlertSubscriptionByModel(filters),
        devicesNotificationsSentByModel(filters),
        devicesNotificationSubscriptionByPropertyName(filters),
        devicesNotificationSentByPropertyName(filters),
      ],
    };
  }

  reportsDescription = () => [
    devicesAlertSubscriptionByModel(),
    devicesNotificationsSentByModel(),
    devicesNotificationSubscriptionByPropertyName(),
    devicesNotificationSentByPropertyName(),
  ];


  render() {
    const { errors, fetchData, session } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);
    return (
      <div className="NotificationAnalysisPage page">
        <TitleBar title="notificationAnalysis">
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              notification_type(this.report(listOfNotificationTypes)),
              property_name,
              display_name,
              dsn(),
            ]}
          />

          <div>
            <BarChart title="notifications.alertSubscription"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(devicesAlertSubscriptionByModel),'Notification_Subscription_By_Model')}
              description={this.reportDescription(devicesAlertSubscriptionByModel)}
              xLabel="model"
              yLabel="devices"
              skipDetailsTranslation
            />
            <BarChart title="notifications.sendByModel"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(devicesNotificationsSentByModel), 'Notifications_Sent_By_Model')}
              description={this.reportDescription(devicesNotificationsSentByModel)}
              xLabel="model"
              yLabel="devices"
              skipDetailsTranslation
            />
          </div>
          <div>
            <BarChart title="notifications.subscriptionsByPropertyName"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(devicesNotificationSubscriptionByPropertyName),'Notification_Subscriptions_By_Property_Name')}
              description={this.reportDescription(devicesNotificationSubscriptionByPropertyName)}
              xLabel="property"
              yLabel="devices"
              skipDetailsTranslation
            />
            <BarChart title="notifications.sendByPropertyName"
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(devicesNotificationSentByPropertyName),'Notifications_Sent_By_Property_Name')}
              description={this.reportDescription(devicesNotificationSentByPropertyName)}
              xLabel="property"
              yLabel="devices"
              skipDetailsTranslation
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(NotificationAnalysisPage);
